import { render, staticRenderFns } from "./OutOfBounds.vue?vue&type=template&id=138ec39b&scoped=true&"
import script from "./OutOfBounds.vue?vue&type=script&lang=js&"
export * from "./OutOfBounds.vue?vue&type=script&lang=js&"
import style0 from "./OutOfBounds.vue?vue&type=style&index=0&id=138ec39b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138ec39b",
  null
  
)

export default component.exports